import { data } from '../../svg/FileCopyOff/data';
import { makeIcon } from '../makeIcon';

export const FileCopyOff = makeIcon(data, 'file_copy_off', 'FileCopyOff');

export default FileCopyOff;
